import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {SelectedStormModeStatusType} from "../../Filters/utils";
import {selectedStormModeSelectorMonitoring, setSelectedStormModeMonitoring} from "../Selectors/filtersSliceMonitoring";

export const useSelectedStormModeMonitoring = () => {
    const dispatch = useDispatch();
    const stormMode = useSelector(selectedStormModeSelectorMonitoring);

    const onSelectStormMode = React.useCallback((selected: SelectedStormModeStatusType) => {
        dispatch(setSelectedStormModeMonitoring(selected));
    }, [dispatch]);

    return {
        stormMode,
        onSelectStormMode,
    };
};